<div>  
  <mat-form-field appearance="legacy" floatLabel="never" class="input-date">
    <input type="hidden"
      [appNumericKeyboard]="true"
      [matDatepicker]="picker"
      [max]="maxDate"
      [min]="minDate"
      (dateChange)='toDate($event)'
      >
    <input matInput
      [formControl]="currentFormControl"
      [appFocus]="requestFocus"
      [appNumericKeyboard]="true"
      [readonly]="readOnly"
      [textMask]="MASCARA"
      [value]="datePicker"
      pattern="\d{2}/\d{2}/\d{4}"
      [placeholder]="placeholder"
      pattern="\d{2}/\d{2}/\d{4}"
      >
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="isInvalid()">{{getErrorMessage()}}</mat-error>
  </mat-form-field>
  <!-- [formControl]="currentFormControl" -->
</div>